import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  color = '#4CAF50', 
  message = 'Loading...',
  fullScreen = false 
}) => {
  const spinnerStyles = {
    small: { width: '20px', height: '20px', borderWidth: '2px' },
    medium: { width: '40px', height: '40px', borderWidth: '3px' },
    large: { width: '60px', height: '60px', borderWidth: '4px' }
  };

  const containerStyle = fullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.9)',
    zIndex: 9999
  } : {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem'
  };

  const spinnerStyle = {
    ...spinnerStyles[size],
    border: `${spinnerStyles[size].borderWidth} solid #f3f3f3`,
    borderTop: `${spinnerStyles[size].borderWidth} solid ${color}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  };

  const messageStyle = {
    marginTop: '1rem',
    color: '#666',
    fontSize: '0.9rem',
    textAlign: 'center'
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={containerStyle}>
        <div style={spinnerStyle}></div>
        {message && <p style={messageStyle}>{message}</p>}
      </div>
    </>
  );
};

export default LoadingSpinner;
